import { createSlice } from '@reduxjs/toolkit';
import { getSettings, setSettings } from '../../lib/useLocalStorageUser';

const settingsDetails = getSettings();

const initialState = {
	theme: 'light',
	lang: 'en',
	bottomPopup: true,
};

const settingsSlice = createSlice({
	name: 'settings',
	initialState: settingsDetails ? settingsDetails : initialState,
	reducers: {
		setSettingsData(state, action) {
			const settingsData = action.payload;
			const settings = { ...state, ...settingsData };
			setSettings(settings);
			return settings;
		},
	},
});

export const { setSettingsData } = settingsSlice.actions;

export default settingsSlice.reducer;
